// dependencies
import { fromJS } from "immutable";
import Cookies from "js-cookie";
import moment from "moment-timezone";
import { GenerateProcess } from "redux-process";

import { dom, library } from "@fortawesome/fontawesome-svg-core";
import { faTheaterMasks } from "@fortawesome/pro-duotone-svg-icons";
import { fal } from "@fortawesome/pro-light-svg-icons";
import { far } from "@fortawesome/pro-regular-svg-icons";
// font awesome
import { fas } from "@fortawesome/pro-solid-svg-icons";

// selectors
import { getUser, getUserID } from "../selectors/app";

// utils
import "../utils/Globalize";
import avatarURL from "../utils/avatarURL";
import ParseFeatures from "./utils/ParseFeatures";

const baseAction = "APPLICATION";

export const fontAwesome = () => () => {
	library.add(fas, far, fal, faTheaterMasks);

	// eslint-disable-next-line
	if ($(".shim-f4-to-f5-container").get(0)) {
		dom.watch({
			autoReplaceSvgRoot: $(".shim-f4-to-f5-container").get(0), // eslint-disable-line
			observeMutationsRoot: $(".shim-f4-to-f5-container").get(0), // eslint-disable-line
		});
	}
};

/**
 * Fetches the number of direct reports for the current user.
 */
export const getUserDirectReportCount = () => async (dispatch, getState) => {
	const state = getState();
	const userID = getUserID(state);

	const request = await dispatch(GenerateProcess("GetDirectReportsCount", { managerID: userID }));

	if (request.succeeded) {
		const userObject = getUser(getState());
		const updatedUserObject = userObject.set("directReportsCount", request.response);
		dispatch({ type: `${baseAction}:USER`, user: updatedUserObject });
	}
};

export function GetUser() {
	return (dispatch) => {
		const user = window._MyUser; // eslint-disable-line no-underscore-dangle

		if (!user) {
			return;
		}

		const userTimezone = moment.tz.guess();

		const userObject = {
			id: user.id,

			company: {
				name: user.company,
				id: user.companyid,
				size: user.company_size,
			},

			directReportsCount: 0,
			name: user.name,
			email: user.email,
			timezone: userTimezone,
			isAdmin: user.is_admin,
			isSuperuser: user.isSuperuser,
			avatarURL: avatarURL(user.id),
			permissionType: user.permissionType,
		};

		try {
			userObject.directReports = user.employees;
		} catch (err) {
			userObject.directReports = [];
		}

		// set the user's TZ in the cookie
		Cookies.set("_tz", userTimezone);

		dispatch({ type: `${baseAction}:USER`, user: fromJS(userObject) });
		dispatch({
			type: `${baseAction}:FEATURES`,
			features: fromJS(ParseFeatures(user.features)),
		});
	};
}

export function SetDebugMode() {
	return (dispatch) => {
		const isDebug = DEBUG;

		dispatch({ type: `${baseAction}:DEBUG`, isDebug });
	};
}

export function MeasureApp() {
	return (dispatch) => {
		/*
            Measures the dimensions of the application.
        */

		const windowWidth =
			window.innerWidth ||
			document.documentElement.clientWidth ||
			document.getElementsByTagName("body")[0].clientWidth;
		const windowHeight =
			window.innerHeight ||
			document.documentElement.clientHeight ||
			document.getElementsByTagName("body")[0].clientHeight;
		const isMobileView = windowWidth <= 750;

		dispatch({
			type: `${baseAction}:MEASURE`,
			isMobileView,
			windowDimensions: { width: windowWidth, height: windowHeight },
		});
	};
}

export function Initialize() {
	return (dispatch) => {
		dispatch(SetDebugMode());
		dispatch({ type: `${baseAction}:INIT` });

		dispatch(GetUser());
		dispatch(MeasureApp());
		dispatch(fontAwesome());

		// get company settings
		dispatch(GenerateProcess("GetCompanySettings"));
	};
}
